import React, { useEffect, useState } from "react";

/**
 * CountdownTimer — counts down to a target date (ISO string).
 * Fires onExpire once when it reaches 0.
 */
export default function CountdownTimer({ target, onExpire, className = "", testId }) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!target) return;
    const targetMs = new Date(target).getTime();
    const tick = () => {
      const diff = Math.max(0, targetMs - Date.now());
      setRemaining(diff);
      if (diff === 0 && onExpire) onExpire();
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [target]);

  const totalSec = Math.floor(remaining / 1000);
  const m = String(Math.floor(totalSec / 60)).padStart(2, "0");
  const s = String(totalSec % 60).padStart(2, "0");
  const urgent = totalSec > 0 && totalSec < 120;
  return (
    <span
      data-testid={testId}
      className={`font-mono font-bold tabular-nums ${urgent ? "timer-urgent" : ""} ${className}`}
    >
      {m}:{s}
    </span>
  );
}
